import { VariableType } from "../VariableType";
import { BaseTypeSchema } from "../BaseTypeSchema";
import { BaseVariableSchema } from "../BaseVariableSchema";
import { BaseSchema } from "../BaseSchema";

export class ObjectSchema extends BaseTypeSchema
{
    name: string;
    fields: BaseVariableSchema[] | null;
    external: { package: string } | null = null;
    constructor(name: string, required: boolean, fields: BaseVariableSchema[] | null)
    {
        super(VariableType.Object, required);
        this.name = name;
        this.fields = fields;
    }
    setFields(fields: BaseVariableSchema[] | null): ObjectSchema
    {
        this.fields = fields;
        return this;
    }
    addField(...fields: BaseVariableSchema[]): ObjectSchema
    {
        if (this.fields == null)
            this.fields = [];
        this.fields.push(...fields);
        return this;
    }
    replaceField(name: string, changer: (field: BaseVariableSchema) => BaseVariableSchema): ObjectSchema
    {
        if (this.fields)
            for (let i = 0; i < this.fields.length; i++)
            {
                const element = this.fields[i];
                if (element.name === name)
                {
                    this.fields[i] = changer(this.fields[i]);
                    return this;
                }
            }
        throw new Error("Couldn't find the field: " + name);
    }
    delField(name: string): ObjectSchema
    {
        if (this.fields)
        {
            let newFeilds = this.fields.filter(x => x.name != name);
            if (newFeilds.length != this.fields.length)
                return this.setFields(newFeilds);
        }
        return this;
    }
    delReadOnly(read_only: boolean, ...exclude_names: string[]): ObjectSchema
    {
        if (this.fields)
        {
            let newFeilds = this.fields.filter(x =>
            {
                if (exclude_names.includes(x.name))
                    return true;
                return x.type.read_only !== read_only
            });
            if (newFeilds.length != this.fields.length)
                return this.setFields(newFeilds);
        }
        return this;
    }
    setExternal(external: { package: string } | null): ObjectSchema
    {
        this.external = external;
        return this;
    }
    override check(): void
    {
        if (this.fields != null)
        {
            BaseSchema.checkRepeated("Object", "field", this.fields, () => "", c => c.name);
            this.fields.forEach(f => f.check());
        }
    }
}